import { create } from 'zustand';

export type CollaboratorsTableView = 'permissions' | 'invites' | 'requests';

interface CollaboratorsTableViewState {
  setTableView: (tableView: CollaboratorsTableView) => void;
  tableView: CollaboratorsTableView;
}

export const useCollaboratorsTableViewStore = create<CollaboratorsTableViewState>((set) => ({
  tableView: 'permissions',
  setTableView: (tableView: CollaboratorsTableView) => set(() => ({ tableView })),
}));
